import * as types from './types';

const initialState = {
  loading: false,
  recievedResponse: false,
  recievedSuccessfulResponse: false,
  recievedErrorResponse: false,
  currentPosting: ''
};

function reservationReducer(state = initialState, action) {
  switch (action.type) {
    case types.SAVE_POSTING_TAG:
      return {
        ...state,
        loading: true,
        recievedResponse: false,
        recievedSuccessfulResponse: false,
        recievedErrorResponse: false,
        currentPosting: action.meta.query.postingId
      };

    case types.SAVE_POSTING_TAG_COMPLETED:
      return {
        ...state,
        loading: false,
        recievedResponse: true,
        recievedSuccessfulResponse: true,
        recievedErrorResponse: false
      };

    case types.SAVE_POSTING_TAG_FAILED:
      return {
        ...state,
        loading: false,
        recievedResponse: true,
        recievedSuccessfulResponse: false,
        recievedErrorResponse: true
      };

    default:
      return state;
  }
}

export default reservationReducer;
